import gameSet from '@/api/administrator/game-set'
import result from '@/api/administrator/game-set-result'
import moment from 'moment'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  date_filter: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_FILTER_DATE(state, date) {
    state.date_filter = date
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    return result.get({
      params: {
        date_filter: context.state.date_filter
      }
    }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return result.store(data)
  },
  update(context, { id, data }) {
    return result.update(id, data)
  },
  destroy(context, id) {
    return result.destroy(id)
  }
}
